import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "shield-yes",
  "use": "shield-yes-usage",
  "viewBox": "0 0 17.09 20",
  "content": "<symbol viewBox=\"0 0 17.09 20\" id=\"shield-yes\"><title>shield-yes</title><path d=\"M18.5,3.1A11.88,11.88,0,0,1,10,0,11.88,11.88,0,0,1,1.5,3.1C1.5,8.7.4,16.7,10,20,19.7,16.7,18.5,8.7,18.5,3.1ZM15.43,7.27l-6.1,6.1a.68.68,0,0,1-.76.14.71.71,0,0,1-.25-.16L5.4,10.44a.72.72,0,0,1,1-1l2.42,2.42,5.59-5.59a.68.68,0,0,1,1,0l0,0A.68.68,0,0,1,15.43,7.27Z\" transform=\"translate(-1.46)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/shield-yes.svg
// module id = L2Nn
// module chunks = 264